var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"gif"},[_c('img',{attrs:{"src":_vm.$root.loadingImage?_vm.$root.loadingImage:'/images/loading_bk.gif',"alt":_vm.$t('altTag',{
                    affiliate:_vm.$root.affiliate
                  })}})])])}
var staticRenderFns = []

export { render, staticRenderFns }